export function isEsimOnly(simType?: string | null) {
  return simType?.trim().toLowerCase() === 'esim'
}

/**
 * SIM type labels come from the catalog as localized display strings
 * (e.g. "Physical SIM + eSIM", "SIM physique + eSIM"). Keep matching on both
 * French and English until the catalog exposes a structured SIM capability.
 */
export function isPhysicalAndEsim(simType?: string | null) {
  const normalizedSimType = simType?.toLowerCase() ?? ''

  return (
    (normalizedSimType.includes('physical') ||
      normalizedSimType.includes('physique')) &&
    normalizedSimType.includes('esim')
  )
}

export function isPhysicalOnly(simType?: string | null) {
  return Boolean(simType) && !isEsimOnly(simType) && !isPhysicalAndEsim(simType)
}

/**
 * Whether the SIM type saved in a phoneline setup can be used with a phone.
 *
 * `esim` is the eSIM flag saved in the phoneline setup: true for an eSIM,
 * false for a physical SIM card, undefined when the setup holds no SIM type
 * choice yet. An absent choice or an unknown phone SIM capability is
 * considered compatible: an incompatibility is only reported when the phone
 * is known to lack the saved SIM type.
 */
export function isSimCompatibleWithPhone(
  esim: boolean | undefined,
  simType?: string | null,
) {
  if (esim === undefined) return true

  if (simType === null || simType === undefined) return true

  if (esim) return isEsimOnly(simType) || isPhysicalAndEsim(simType)

  return isPhysicalOnly(simType) || isPhysicalAndEsim(simType)
}
